<script>
    import {Form} from '../../../../helpers/Form/Form'
    import {Gtag} from '../../../../mixins/ga'

    export default {
        mixins: [Gtag],
        props: ['source'],
        data() {
            return {
                trackingClass: [],
                showConfirm: false,
                form: new Form({
                    contacted: false,
                    reservation_id: null,
                    message: '',
                    reservation_status: null,
                    to: null
                })
            }
        },
        computed: {
            replyHref() {
                if (!_.isEmpty(this.form.to)) {
                    return `mailto:${this.form.to}`
                }
                return ':;'
            },
        },
        mounted() {
            this.$bus.$on('update-reservation-response', this.updateForm)
            this.$bus.$on('update-reservation-contact', ({reservation}) => {
                this.form.setData('reservation_id', reservation.id)
                this.form.setData('contacted', true)
                this.form.setData('to', reservation.email)
                
                this.$set(this, 'trackingClass', ['platform-reservationOnMessage-trysmd'])
            })

            $(this.$refs.reservationModal)
                .on('hidden.bs.modal', () => {
                    this.onClose()
                })
        },
        methods: {
            onClose() {
                setTimeout(() => {
                    this.showConfirm = false
                    this.form.reset()
                }, 1000)
            },
            updateForm({ reservation, status, email }) {
                this.form.setData('reservation_id', reservation.id)
                this.form.setData('reservation_status', status)
                this.form.setData('to', reservation.email)

                if (!this.form.reservation_status) {
                    this.$set(this, 'trackingClass', 'platform-reservationRejected-trysmd')
                } else {
                    this.$set(this, 'trackingClass', 'platform-reservationAccepted-trysmd')
                }
            },
            onSubmit() {
                this.form
                    .submit('post', this.source)
                    .then(({reservation}) => {
                        this.form.setData('to', reservation.email)
                        this.showConfirm = true

                        window.alerts.success('Prenotazione aggiornata correttamente');

                        this.$bus.$emit('update-reservation', {reservation})
                    })
            },
            onInfo() {
                this.sendGaEvent('Click cta', this.category, this.label)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/partials/ReservationResponseForm.vue